import { useContext } from 'react';
import {
  CorporateBondScreenerSidebarFilterContext,
  type CorporateBondScreenerSidebarFilterContextType,
} from './CorporateBondScreenerSidebarFilterContext';

export const useCorporateBondScreenerSidebarFilterContext = (): CorporateBondScreenerSidebarFilterContextType => {
  const context = useContext(CorporateBondScreenerSidebarFilterContext);

  if (!context) {
    throw new Error(
      'useCorporateBondScreenerSidebarFilterContext must be used within CorporateBondScreenerSidebarFilterProvider',
    );
  }

  return context;
};
